import React from "react";

const InternalBodyHeading = (props) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div
            className={`section-title text-center pt--${props.paddingTop} mb--${props.marginBottom} service-style--3`}>
            <h2 className={`title ${props.className}`}>{props.title}</h2>
            <p>
              {props.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalBodyHeading;
